import React, { useState } from 'react';
import jsPDF from 'jspdf';
import emailjs from '@emailjs/browser';

// Basit bileşenler
const Input = ({ ...props }) => (
  <input
    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring focus:border-blue-300"
    {...props}
  />
);

const Textarea = ({ ...props }) => (
  <textarea
    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring focus:border-blue-300"
    {...props}
  />
);

const Button = ({ children, ...props }) => (
  <button
    className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
    {...props}
  >
    {children}
  </button>
);

const Card = ({ children }) => (
  <div className="bg-white shadow-lg rounded-xl p-6">{children}</div>
);

const CardContent = ({ children }) => <div>{children}</div>;

const EpostaTeklifGonder = () => {
  const [formData, setFormData] = useState({
    aliciEmail: '',
    konu: '',
    mesaj: '',
  });

  const [durum, setDurum] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text('📄 Teklif Bilgisi', 20, 20);

    doc.setFontSize(12);
    doc.text(`Konu: ${formData.konu}`, 20, 35);
    doc.text(`Alıcı: ${formData.aliciEmail}`, 20, 45);
    doc.text(`Tarih: ${new Date().toLocaleString()}`, 20, 55);

    const mesaj = doc.splitTextToSize(formData.mesaj, 170);
    doc.text('Mesaj:', 20, 70);
    doc.text(mesaj, 20, 80);

    return doc.output('blob');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDurum('');
    setLoading(true);

    try {
      const pdfBlob = generatePDF();

      // E-Posta Gönder
      await emailjs.send(
        'service_e36rkkg',
        'template_37dp2bf',
        {
          to_email: formData.aliciEmail,
          subject: formData.konu,
          message: formData.mesaj,
        },
        'xtvejGONmFTFxHOnf'
      );

      // Teklif geçmişine kaydet
      const gecmis = JSON.parse(localStorage.getItem('teklifGecmisi')) || [];
      gecmis.push({
        aliciEmail: formData.aliciEmail,
        konu: formData.konu,
        mesaj: formData.mesaj,
        tarih: new Date().toLocaleDateString(),
      });
      localStorage.setItem('teklifGecmisi', JSON.stringify(gecmis));

      setDurum('✅ E-posta başarıyla gönderildi ve geçmişe kaydedildi!');
      setFormData({ aliciEmail: '', konu: '', mesaj: '' });
    } catch (error) {
      console.error('E-posta gönderim hatası:', error);
      setDurum('❌ Gönderim sırasında bir hata oluştu.');
    }

    setLoading(false);
  };

  return (
    <div className="max-w-2xl mx-auto mt-10 px-4">
      <Card>
        <CardContent>
          <h2 className="text-2xl font-semibold mb-6">📧 E-Posta ile Teklif Gönder</h2>
          <form onSubmit={handleSubmit} className="space-y-5">
            <Input
              name="aliciEmail"
              type="email"
              placeholder="Alıcı E-posta"
              value={formData.aliciEmail}
              onChange={handleChange}
              required
            />
            <Input
              name="konu"
              type="text"
              placeholder="Konu"
              value={formData.konu}
              onChange={handleChange}
              required
            />
            <Textarea
              name="mesaj"
              placeholder="Mesajınızı buraya yazın..."
              rows={6}
              value={formData.mesaj}
              onChange={handleChange}
              required
            />
            <Button type="submit" disabled={loading}>
              {loading ? 'Gönderiliyor...' : '📄 PDF Oluştur ve Gönder'}
            </Button>
          </form>
          {durum && (
            <p className="mt-4 text-sm font-medium text-center text-green-600">{durum}</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default EpostaTeklifGonder;
